var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initialState = {
    isViewOnlyMode: false,
};
var uiReducer = function (state, _a) {
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case 'SET_VIEW_ONLY_MODE':
            return __assign(__assign({}, state), { isViewOnlyMode: true });
        default:
            return state;
    }
};
export default uiReducer;



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/ui.reducer.ts
// module id = 1457
// module chunks = 81